<template>
  <div id="app">
      <router-view></router-view>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
export default {
  name: 'app'
}
</script>

<style>
  .btn.btn-primary{
    background: #84B44C;
    border: 1px solid #84B44C;
    border-radius: 0;
  }
  .btn.btn-primary:focus,
  .btn.btn-primary:active,
  .btn.btn-primary:hover{
    color: #84B44C;
    border: 1px solid #84B44C;
    background: #fff;
  }
  .topbutton .btn{
    width: 100%;
  }
  @media(min-width: 768px){
    .topbutton{
      top: 15px;
      right: 15px;
      z-index: 9000;
      opacity: 1;
      position: fixed;
    }
    .topbutton .btn.btn-primary{
      width: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?7e69ea80